import { MouseEvent, useMemo, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Text, { ITextProps } from '../../atoms/Text';
import Badge from '../Badge';
import { formatWallet } from '../../components/Modal/WalletModal/formatters';
import { createGetFromWalletTags } from '../../selectors/walletTags';
import { actionShowModal } from '../../actions/modal';
import { ModalTypes } from '../../reducers/modal';

import './styles.scss';

interface IWalletFieldProps {
  wallet: string;
  network: string;
  textProps: Omit<ITextProps, 'children'>;
  analyzeLink?: boolean;
  showTag?: boolean;
}

const WalletField = ({
  wallet,
  network,
  textProps,
  analyzeLink,
  showTag = true,
}: IWalletFieldProps) => {
  const selectFromWalletTags = useMemo(
    () => createGetFromWalletTags(wallet, network),
    [wallet, network]
  );

  const currentTag = useSelector(selectFromWalletTags);

  const dispatch = useDispatch();

  const divRef = useRef<HTMLDivElement>(null); // Ref for div element
  const linkRef = useRef<HTMLAnchorElement>(null); // Ref for Link element

  const onEdit = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = (
      analyzeLink ? linkRef : divRef
    ).current?.getBoundingClientRect();
    if (rect) {
      dispatch(
        actionShowModal(ModalTypes.editWalletTag, {
          wallet,
          network,
          currentTag,
          x: rect.x - 70,
          y: rect.y - 140,
        })
      );
    }
  };

  if (analyzeLink) {
    return (
      <Link
        to={`/en/wallet-overview/${network}/${wallet}`}
        className='wallet_field'
        ref={linkRef}
      >
        <div className='wallet_field__analyze icon-wallet' />
        <Text {...textProps}>{formatWallet(wallet)}</Text>
        <div className='wallet_field__edit icon-edit' onClick={onEdit} />
        {currentTag && showTag && (
          <Badge variant='fill' klass='green' text={currentTag} />
        )}
      </Link>
    );
  }

  return (
    <div className='wallet_field' ref={divRef}>
      <Text {...textProps}>{formatWallet(wallet)}</Text>
      <div className='wallet_field__edit icon-edit' onClick={onEdit} />
      {currentTag && showTag && (
        <Badge variant='fill' klass='green' text={currentTag} />
      )}
    </div>
  );
};

export default WalletField;
